import { typesEndpoint } from '../../../common/types';
import { axiosApi } from '../../../lib/axios';

export async function postGenerateOTP({
  idOportunidad,
  telefono,
  valueAccepted = [],
}) {
  const url = typesEndpoint.postGenerateOTP;

  const body = {
    idOportunidad,
    telephone: telefono,
    valueAccepted,
  };

  const response = await axiosApi.post(url, body);

  return response;
}

export async function postValidateOTP({ idOportunidad, code }) {
  const url = typesEndpoint.postValidateOTP;

  const body = {
    idOportunidad,
    code,
  };

  const response = await axiosApi.post(url, body);

  return response;
}
